import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const NotaryCard = ({
  title,
  value,
  icon: IconComponent,
  color,
  tooltip,
  isUpcoming,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card
      raised
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "100%",
        minHeight: {
          xs: "120px", // Mobile: ensure minimum height for touch targets
          sm: "140px", // Tablet: medium height
          md: "160px", // Desktop: larger height
        },
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        "&:hover": {
          transform: {
            xs: "none", // Mobile: no hover effects to avoid touch issues
            sm: "translateY(-2px)", // Tablet and up: subtle hover effect
          },
          boxShadow: {
            xs: 3, // Mobile: keep original shadow
            sm: 6, // Tablet and up: enhanced shadow on hover
          },
        },
      }}
    >
      <CardContent
        sx={{
          flexGrow: 1,
          p: {
            xs: 2, // Mobile: smaller padding
            sm: 2.5, // Tablet: medium padding
            md: 3, // Desktop: original padding
          },
        }}
      >
        <Typography
          variant={isMobile ? "body1" : "h6"}
          color="GrayText"
          sx={{
            fontSize: {
              xs: "0.875rem", // Mobile: smaller title
              sm: "1rem", // Tablet: medium title
              md: "1.25rem", // Desktop: original h6 size
            },
            fontWeight: {
              xs: 500, // Mobile: medium weight
              sm: 600, // Tablet and up: semibold
            },
          }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pt: {
              xs: 1.5, // Mobile: smaller top padding
              sm: 2, // Tablet and up: original padding
            },
          }}
        >
          <Typography
            variant={
              isUpcoming ? (isMobile ? "body1" : "h6") : isMobile ? "h6" : "h5"
            }
            sx={{
              fontSize: {
                xs: isUpcoming ? "0.875rem" : "1.25rem", // Mobile: smaller values
                sm: isUpcoming ? "1rem" : "1.5rem", // Tablet: medium values
                md: isUpcoming ? "1.25rem" : "1.75rem", // Desktop: original sizes
              },
              fontWeight: {
                xs: 600, // Mobile: semibold
                sm: 700, // Tablet and up: bold
              },
              wordBreak: "break-word", // Prevent text overflow
              lineHeight: 1.2,
            }}
          >
            {value}
          </Typography>
          <Tooltip title={tooltip} placement={isMobile ? "top" : "right"} arrow>
            <IconComponent
              fontSize={isMobile ? "medium" : "large"}
              sx={{
                color,
                fontSize: {
                  xs: "1.5rem", // Mobile: smaller icons
                  sm: "2rem", // Tablet: medium icons
                  md: "2.5rem", // Desktop: original large size
                },
              }}
            />
          </Tooltip>
        </Box>
      </CardContent>
    </Card>
  );
};

export default NotaryCard;
